__webpack_require__.p = "https://cdn.tapresearch.com/packs/";